import { useCallback, useState } from 'react'
import AuthService from '../../../services/auth-service'

const useForgotPassword = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [input, setEmail] = useState({
    email: '',
  })
  const [error, setError] = useState({
    err: false,
    textError: '',
  })

  const handleChange = useCallback(e => {
    setEmail({
      [e.target.name]: e.target.value,
    })
  }, [])

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault()

      const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

      if (
        input.email.trim().length === 0 ||
        !input.email.trim().match(mailFormat)
      ) {
        setError({ err: true, textError: 'Adresa de email nu este validă' })
        return
      }

      // something not right with the data
      const myData = {
        email: input.email,
      }

      setSuccess(null)
      setIsLoading(true)
      AuthService.forgotPassword(myData)
        .then(response => {
          if (response.hasOwnProperty('errors')) {
            if (response.errors.hasOwnProperty('email')) {
              setError({ err: true, textError: response.errors.email[0] })
            } else {
              setError({
                err: true,
                textError:
                  'A apărut o eroare. Dacă persistă, te rugăm să ne contactezi.',
              })
            }
            setSuccess(false)
            return null
          } else {
            setError({ err: false, textError: '' })
            setSuccess(true)
          }
        })
        .finally(() => {
          setIsLoading(false)
        })
    },
    [input],
  )

  return { success, input, handleChange, handleSubmit, error, isLoading }
}

export default useForgotPassword
